import './LinkTextField.scss';

import { ReactNode, useMemo } from 'react';
import { Link, useNavigate } from 'react-router';

import { ADMIN_URL, PLATFORM_URL } from '@/constants/urls';

interface BaseLinkTextFieldProps {
  label: ReactNode;
  to: string;
  className?: string;
  withoutColor?: boolean;
  newTab?: boolean;
}

type AdminLink = BaseLinkTextFieldProps & {
  admin: true;
  platform?: never;
  local?: never;
  external?: never;
};

type PlatformLink = BaseLinkTextFieldProps & {
  admin?: never;
  platform: true;
  local?: never;
  external?: never;
};

type LocalLink = BaseLinkTextFieldProps & {
  admin?: never;
  platform?: never;
  local: true;
  external?: never;
};

type ExternalLink = BaseLinkTextFieldProps & {
  admin?: never;
  platform?: never;
  local?: never;
  external: true;
};

type LinkTextFieldProps = AdminLink | PlatformLink | LocalLink | ExternalLink;

const LinkTextField = (props: LinkTextFieldProps) => {
  const navigate = useNavigate();
  const { label, to, admin, platform, local, className, withoutColor, newTab } = props;
  const route = useMemo(
    () => (admin ? `${ADMIN_URL}${to}` : platform ? `${PLATFORM_URL}${to}` : `${to}`),
    [admin, platform, to],
  );

  return (
    <Link
      to={route}
      target="_blank"
      rel="noopener noreferrer"
      className={`LinkTextField ${withoutColor ? 'LinkTextFieldWithoutColor' : ''} ${className ?? ''}`}
      onClick={e => {
        if (local && !newTab && !e.ctrlKey && !e.metaKey) {
          e.preventDefault(); // evita que se abra en una nueva pestaña
          void navigate(route);

          return;
        }
      }}>
      {label}
    </Link>
  );
};

export default LinkTextField;
